<template>
  <div class="exam">
    <div class="nuv">
      <!-- <a href="/tjkStudy/examlist" class="active">考试中心</a>&gt;<span>{{ data.examName }}</span> -->
    </div>
    <div class="result-con">
      <div class="count">
        <h2>考试结果</h2>
        <div class="useTime">
          <template v-if="data.isCorrect == 'no'">
            <p><span class="result-txt">请耐心等待批阅，考试结果会在消息中心公布</span></p>
            <p>用时：<span class="blue">{{ getTime(data.examTimeSpent) }}</span></p>
            <!-- <p class="txt">满分{{ data.examTotalScore }}分，{{ data.examPassScore }}分及格</p> -->
          </template>
          <template v-else>
            <p>
              <span class="result-txt" v-if="data.isPassed == 'passed'">恭喜您已通过考试</span>
              <span class="result-txt" v-if="data.isPassed == 'failed'">很遗憾您未通过考试</span>
            </p>
            <p>用时：<span class="blue">{{ getTime(data.examTimeSpent) }}</span></p>
            <p>得分：<span class="num">{{ data.tjkScore }}分</span></p>
            <!-- <p class="txt">满分{{ data.examTotalScore }}分，{{ data.examPassScore }}分及格</p> -->
          </template>
        </div>
        <ul>
          <li v-for="s in list" :class="{active2: s.answerState == 'right', active4: s.answerState == 'wrong', active1: s.answerState == 'halfRight'}">{{ s.num }}</li>
        </ul>
        <div class="color-txt"><span class="right">正确</span><span class="wrong">错误</span><span class="halfright">部分正确</span><span class="waitGrade">待批阅</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      'success': true,
      'message': '',
      'id': this.$route.params.id,
      'data': {},
      'paperQuestion': [],
      'num': [],
      'savelist': [],
      'list': [] //保存时的结果集转换的一维数组，用作答题卡
    }
  },
  mounted: function() {
    this.getExam()
  },
  watch: {
    paperQuestion: function() {
      for(var i=0;i<this.paperQuestion.length;i++) {
        var xti = []
        var numlength = parseInt(this.num.length)
        for(var j=0;j<this.paperQuestion[i].questionDetailList.length;j++) {
          this.num.push(j)
          var temp = {
            'num': numlength+j+1,
            'answerState': this.paperQuestion[i].questionDetailList[j].answerState
          }
          xti.push(temp)
        }
        this.savelist.push(xti)
      }
      this.list = [].concat.apply([], this.savelist)
    }
  },
  methods: {
    getExam() {
      var data = {
        'examRecordId': this.id
      }
      this.$http.post(API_ROOT.system + '/tjkExam/getTjkExamDetail', data).then(response => {
        var result = response.data
        this.success = result.success
        this.message = result.msg
        if (result.success) {
          this.data = result.data
          this.paperQuestion = result.data.allTjkAnswerDetailList
        }else {
          alert(result.msg)
        }
      }, response => {
        alert('网络繁忙，请稍后重试！')
      })
    },
    getTime(second) {
      var sec = parseInt(second)
      var min = 0
      var hour = 0  
      if(sec >= 60) {
        min = parseInt(sec/60)
        sec = parseInt(sec%60)
        if(min >= 60) {
          hour = parseInt(min/60)
          min = parseInt(min%60)
        }
      }
      hour = hour < 10 ? "0" + hour : hour
      min = min < 10 ? "0" + min : min
      sec = sec < 10 ? "0" + sec : sec
      if(hour > 0 ) {
        return `${hour}小时${min}分钟${sec}秒`
      }else {
        return `${min}分钟${sec}秒`
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ./src/page/examResult.vue